export default __webpack_public_path__ + "static/media/panda_white_logo.ecca8f98.png";